export enum ConsultNoteQueueCursorType {
  mostRecentlyCreated = 'most_recently_created',
  leastRecentlyCreated = 'least_recently_created',
  highestPendingEstimatedValue = 'highest_pending_estimated_value',
  highestWipEstimatedValue = 'highest_wip_estimated_value',
  highestPendingHighValueCount = 'highest_pending_high_value_count',
  highestPriority = 'highest_priority',
}
